module.exports = __webpack_public_path__ + "static/media/ElevenSports_Belgio.e9f8c775.png";